import React, { useState, useEffect } from 'react';
import { ref, getDownloadURL } from 'firebase/storage';
import { storage } from '../../config/fbConfig';
import { Image } from 'react-bootstrap';

const NewsImageComponent = ({ imageName, index, handleOnClickCallback }) => {
    const [imageUrl, setImageUrl] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const pathAndFile = 'news/thumb_' + imageName;

    useEffect(() => {
        // Function to get download URL from Firebase Storage
        const getDownloadUrl = async () => {
            try {
                const imageRef = ref(storage, pathAndFile);
                const url = await getDownloadURL(imageRef);
                setImageUrl(url);
                setIsLoading(false);
            } catch (error) {
                console.error('Error getting download URL:', error);
                setIsLoading(false);
            }
        };

        // Call the function to get download URL when component mounts
        if (imageName) {
            getDownloadUrl();
        } else {
            //setIsLoading(false);
        }

    }, [pathAndFile]); // Run this effect when logoPath changes

    return (

        <div className="me-2 mb-2" style={{ position: 'relative', height: '180px' }}>
            {isLoading ? (
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            ) : (
                <Image
                    src={imageUrl}
                    alt=""
                    thumbnail
                    className="news-image"
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleOnClickCallback(index)}
                />
            )}
        </div>

    );
}

export default NewsImageComponent;